import { SideMenu } from './side-menu';
import MobileNavigation from './mobile-navigation';
import ThirdPartyLinksHandler from '../shared/third-party-links-handler';

export default class Support {
  sideMenu = new SideMenu();
  mobileNavigation = new MobileNavigation();
  containerId = 'support-container';
  thirdPartyLinksHandler = new ThirdPartyLinksHandler();

  showSupport = () => {
    this.mobileNavigation.closeMenu();
    this.sideMenu.show(this.containerId);
    this.thirdPartyLinksHandler.showForSideBar();
  };

  closeSupport = () => {
    this.sideMenu.hide(this.containerId);
    this.thirdPartyLinksHandler.hideForSideBar();
  };

  initializeEventListeners = () => {
    const supportMenu = document.getElementById('desktop-navigation-support');
    const supportMenuClose = document.getElementById('support-menu-close');

    if (supportMenu) {
      supportMenu.addEventListener('click', this.showSupport);
    }

    if (supportMenuClose) {
      supportMenuClose.addEventListener('click', this.closeSupport);
    }
  };
}
